import { JobseekerSubscriptionState } from "./state";
import { createImmerReducer } from 'ngrx-immer/store';
import * as JobseekerSubscriptionActions from './actions';
import { on, Action } from '@ngrx/store';

const initialState: JobseekerSubscriptionState = {
    loading: false,
    subscription: null,
    isEditMode: false,
    selectedSpecializations: [],
    selectedLocations: [],
    selectedSeniorityLevels: [],
    specializationsTouched: false,
    jobseekerSubscriptionLookup: null,
    subscriptionLoadFailureDetails: null,
    subscriptionUpdateFailureDetails: null,
    subscriptionUnsubscribeFailureDetails: null,
}

const reducer = createImmerReducer(
    initialState,

    on(JobseekerSubscriptionActions.updateSelectedSpecializations, (state, { payload }) => {
        state.selectedSpecializations = state.selectedSpecializations.filter(c => c.id != payload.specialization.id);
        if (payload.checked) {
            state.selectedSpecializations = [...state.selectedSpecializations, payload.specialization];
        }

        if (!state.specializationsTouched) {
            state.specializationsTouched = true;
        }

        return state;
    }),

    on(JobseekerSubscriptionActions.loadSubscription, state => {
        state.loading = true;
        return state;
    }),

    on(JobseekerSubscriptionActions.loadSubscriptionSuccess, (state, { payload }) => {
        state.loading = false;
        state.subscription = payload;
        state.selectedSpecializations = payload.specializations;
        state.selectedLocations = payload.locations;
        state.selectedSeniorityLevels = payload.seniorityLevels;
        return state;
    }),

    on(JobseekerSubscriptionActions.loadSubscriptionFail, (state, { payload }) => {
        state.loading = false;
        state.subscriptionLoadFailureDetails = payload;
        return state;
    }),

    on(JobseekerSubscriptionActions.updateSubscription, state => {
        state.loading = true;
        return state;
    }),

    on(JobseekerSubscriptionActions.updateSubscriptionSuccess, (state, { payload }) => {
        state.loading = false;
        state.subscription = payload;

        return state;
    }),

    on(JobseekerSubscriptionActions.updateSubscriptionFail, (state, { payload }) => {
        state.loading = false;
        state.subscriptionUpdateFailureDetails = payload;

        return state;
    }),

    
    on(JobseekerSubscriptionActions.unsubscribeJobseeker, state => {
        state.loading = true;
        return state;
    }),

    on(JobseekerSubscriptionActions.unsubscribeJobseekerSuccess, (state) => {
        state.loading = false;
        state.selectedLocations = [];
        state.selectedSpecializations = [];
        state.selectedSeniorityLevels = [];
        state.subscription.locations = [];
        state.subscription.specializations = [];
        state.subscription.seniorityLevels = [];
        return state;
    }),

    on(JobseekerSubscriptionActions.unsubscribeJobseekerFail, (state, { payload }) => {
        state.loading = false;
        state.subscriptionUnsubscribeFailureDetails = payload;

        return state;
    }),

    on(JobseekerSubscriptionActions.loadJobseekerSubscriptionLookup, state => {
        state.loading = true;

        return state;
    }),

    on(JobseekerSubscriptionActions.loadJobseekerSubscriptionLookupSuccess, (state, { payload }) => {
        state.loading = false;
        state.jobseekerSubscriptionLookup = payload

        return state;
    }),

    on(JobseekerSubscriptionActions.loadJobseekerSubscriptionLookupFail, (state, { payload }) => {
        state.loading = false;

        return state;
    }),

    on(JobseekerSubscriptionActions.activateEditMode, (state) => {
        state.isEditMode = true;

        return state;
    })

);

export function jobseekerSubscriptionReducer(state: JobseekerSubscriptionState | undefined, action: Action) {
    return reducer(state, action);
}